var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDpLogoTextGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2469 513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:#47ba3e;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -567.167,
    y1: 862.277,
    x2: -562.952,
    y2: 862.277,
    gradientTransform: "translate(109057.353 71567.814) rotate(90) scale(126.231)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47ba3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d944a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -567.166,
    y1: 855.36,
    x2: -562.949,
    y2: 855.36,
    gradientTransform: "translate(109328.09 71567.298) rotate(90) scale(126.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -567.178,
    y1: 857.259,
    x2: -562.961,
    y2: 857.259,
    gradientTransform: "translate(109256.87 71569.268) rotate(90) scale(126.233)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -567.163,
    y1: 853.606,
    x2: -562.946,
    y2: 853.606,
    gradientTransform: "translate(109398.042 71567.779) rotate(90) scale(126.232)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -567.163,
    y1: 859.092,
    x2: -562.949,
    y2: 859.092,
    gradientTransform: "translate(109180.466 71566.716) rotate(90) scale(126.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -567.179,
    y1: 850.978,
    x2: -562.916,
    y2: 850.978,
    gradientTransform: "translate(109499.083 71566.244) rotate(90) scale(126.229)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -567.17,
    y1: 849.481,
    x2: -562.924,
    y2: 849.481,
    gradientTransform: "translate(109558.088 71566.883) rotate(90) scale(126.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -567.174,
    y1: 860.514,
    x2: -562.96,
    y2: 860.514,
    gradientTransform: "translate(109128.514 71568.739) rotate(90) scale(126.232)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -567.194,
    y1: 852.295,
    x2: -562.949,
    y2: 852.295,
    gradientTransform: "translate(109453.509 71570.332) rotate(90) scale(126.235)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,412.045V34.661c2.952,0,5.482-.422,8.012-.422,50.177,0,100.776,0,150.954.843,90.657,1.687,163.6,61.14,179.626,148.845,11.806,63.67-.843,121.859-46.382,170.35-29.516,32.046-67.465,48.912-110.474,54.816-14.336,2.108-29.094,2.53-43.852,2.53-42.587.422-85.175,0-127.762,0A74.734,74.734,0,0,1,40,412.045Zm88.548-69.152c26.143,0,51.864,2.108,77.163-.422,38.793-4.217,64.514-26.986,77.585-63.249s13.071-73.369.422-109.631c-13.493-39.214-41.744-61.984-83.067-65.779-23.191-2.108-47.226-.422-70.417-.422-.422,0-.843.422-1.687,1.265C128.548,183.506,128.548,263.2,128.548,342.893Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1212.21,34.661c2.98,0,5.96-.422,8.94-.422,45.977,0,92.38-.422,138.357.843a238.377,238.377,0,0,1,59.6,10.12c54.066,17.71,80.885,56.924,80.885,113.426,0,60.3-30.226,101.62-88.548,118.064-18.306,5.06-38.314,6.747-57.471,8.012-17.454,1.265-34.909.422-53.214.422V410.78H1212.21Q1212.21,223.564,1212.21,34.661ZM1301.18,218.5c21.083,0,40.9,1.265,61.14-.422,26.564-2.108,41.744-17.288,46.382-43.009a107.084,107.084,0,0,0,1.265-23.191c-2.108-27.408-17.288-45.539-44.7-48.912-20.661-2.53-41.744-1.265-62.827-1.687-.422,0-.843.843-1.687,1.687v110.9C1300.758,214.709,1301.18,216.4,1301.18,218.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M987.861,172.965c10.173-7.59,18.651-15.6,28.824-21.5,45.356-26.143,108.94-21.926,136.492,40.9,25.009,57.346,25.433,115.113-7.206,170.35-24.586,41.744-72.485,61.14-118.689,48.491-11.445-3.373-22.466-10.12-34.335-15.6v99.511H912.832V142.606c18.651,0,37.726-.843,56.377.422,4.239.422,9.326,7.168,12.293,11.806C984.894,160.315,985.742,167.062,987.861,172.965Zm5.087,108.788v49.756a17.156,17.156,0,0,0,3.373,10.12c22.348,24.456,66.2,18.131,78.85-11.806,15.18-35.419,14.336-71.682,1.265-107.523-5.482-15.18-17.71-22.77-34.154-22.77-18.131,0-33.733,6.325-45.539,20.661a25.261,25.261,0,0,0-4.217,10.541C992.948,248.02,992.948,264.886,992.948,281.753Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1784.4,281.753c-3.373,16.023-5.06,32.468-10.12,47.647-12.65,39.214-38.793,65.779-78.007,78.85-35.841,11.806-72.1,11.385-107.1-2.108-35.419-13.493-59.876-38.793-72.525-74.633-11.385-33.733-12.228-67.887-2.108-101.62,12.228-41.323,39.214-70,80.958-82.645,53.129-15.6,103.728-11.385,147.159,27.408,26.986,24.035,37.528,56.081,40.058,91.5.422,5.06.422,10.12.843,15.6C1783.557,281.331,1784.4,281.331,1784.4,281.753Zm-83.488,1.265c-1.687-15.6-2.108-26.564-3.795-37.106a80.145,80.145,0,0,0-4.638-16.445c-8.011-20.24-22.77-29.938-45.539-29.938-24.035,0-40.058,9.276-47.226,29.938a144.363,144.363,0,0,0,0,97.825c7.59,20.661,24.035,29.938,48.491,29.516,21.5-.422,37.528-10.541,43.852-30.781C1696.7,310.425,1698.382,294.4,1700.912,283.018Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M874.883,277.958c-.422,39.214-10.963,75.055-40.058,102.885-23.613,22.77-52.707,32.889-85.175,35-43.431,2.53-82.645-7.59-113.848-40.058-14.758-15.6-24.456-33.733-29.938-54.394-7.59-29.938-8.011-59.454.422-89.392,11.806-41.323,37.949-70,78.428-83.91,35.419-12.65,71.682-12.65,107.1.422,50.6,18.553,75.9,56.924,82.223,109.209a111.11,111.11,0,0,1,.843,11.806Zm-194.806.422c3.795,16.445,5.482,33.733,11.385,49.756,7.59,21.5,26.143,28.673,47.647,27.829,20.661-.422,36.263-9.7,43.431-29.094,11.385-32.468,11.806-65.357.422-97.825-7.168-20.661-23.191-29.938-46.8-29.516-22.77,0-39.214,9.7-45.961,30.359C685.137,245.068,683.45,261.513,680.077,278.379Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2042.876,410.78h-84.332V143.87c21.5,0,39.214-.422,57.345,0,7.168,0,11.806,5.06,14.336,11.806,1.687,4.638,3.373,9.7,5.06,15.6,4.638-3.795,8.855-7.168,13.071-10.12,26.143-20.24,56.08-26.143,87.7-19.4,35.841,7.59,60.3,35.419,66.2,74.212,1.265,8.012,2.108,16.445.843,24.878V405.72c1.265,2.108.843,9.276.843,9.276h-80.958V248.863a39.706,39.706,0,0,0,.422-12.228c-2.53-28.251-19.818-41.744-46.8-34.576-11.385,2.952-21.5,10.541-31.624,16.866-2.108,1.265-2.952,6.325-2.108,9.7V410.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2270.017,199.951h-21.008c-10.924-.424-16.386-5.516-16.386-16.548V152c12.6-2.546,24.369-5.092,36.133-7.213,5.042-.849,7.143-2.97,8.4-8.062,4.2-18.67,8.823-37.764,13.445-56.433,2.941-11.881,6.722-14.851,18.487-15.275h41.6v80.115h67.465v54.816h-67.465V333.609c1.681,19.094,13.025,25.883,30.251,17.821,10.084-4.667,13.445-3.819,19.327,5.092,7.563,11.456,14.705,23.337,22.268,35.218a40.132,40.132,0,0,0,1.681,4.243c-10.924,5.092-21.008,11.032-32.352,14.851a125.24,125.24,0,0,1-60.082,5.516c-35.293-5.092-60.082-32.672-60.923-70.435-.84-44.977-.42-90.378-.42-135.355A72.994,72.994,0,0,1,2270.017,199.951Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M499.608,410.78H419.492V143.027c18.975,0,37.528-.422,56.081,0,6.747.422,11.385,5.06,13.071,12.228,1.687,8.433,3.373,17.288,5.06,25.721,8.012-8.855,15.18-18.553,23.191-26.564,17.288-17.288,44.274-21.926,64.514-13.071,5.482,2.53,8.011,5.06,7.168,11.806-2.108,16.023-2.952,32.046-4.217,48.069-.843,11.385-5.482,14.758-16.866,13.915-10.12-.843-20.661-2.108-30.781-1.265-19.4,1.687-37.106,22.77-37.106,42.166v145.05C499.608,404.034,499.608,407.407,499.608,410.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1903.729,410.78h-80.115V140.919h80.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1864.937,22.855c27.408,0,48.912,21.5,48.491,47.647-.422,25.721-22.77,45.961-49.334,45.961s-48.069-21.5-48.069-47.226C1816.446,43.094,1837.951,22.855,1864.937,22.855Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpLogoTextGreen);
export default __webpack_public_path__ + "static/media/dp-logo-text-green.c2d9086ebc6fae25d9dc603c0c0c2dbb.svg";
export { ForwardRef as ReactComponent };